// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2xE9_","box":"WorkspacesBox_box__1Ue4x","node":"WorkspacesBox_node__3h85q"};